import type {
    Filter,
    QueryFilter as TQueryFilter,
} from '@schibsted-nmp/search-frontend-clients/quest';
import React from 'react';
import { useSearchData } from '../../data/SearchData';
import { SavedSearch } from '../saved-search/SavedSearch';
import { SavedSearchButton } from '../saved-search/SavedSearchButton';
import { QueryFilter } from './query/QueryFilter';

type SearchToolbarProps = {
    className?: string;
};

export function SearchToolbar(props: SearchToolbarProps) {
    const { className = '' } = props;

    const { searchData } = useSearchData();

    const queryFilter = searchData?.filters?.find(isQueryFilter);

    if (!queryFilter) {
        return null;
    }

    return (
        <div className={`${className} flex items-stretch`}>
            <QueryFilter className="grow" filter={queryFilter} />
            <SavedSearch alwaysShow>
                {({ isSaveable, onClick }) => (
                    <SavedSearchButton
                        className="ml-16"
                        disabled={!isSaveable}
                        onClick={onClick}
                    />
                )}
            </SavedSearch>
        </div>
    );
}

function isQueryFilter(filter: Filter): filter is TQueryFilter {
    return filter.type === 'QUERY_FILTER';
}
